import React from 'react'
// import Artiste from 'components/blocks/Artiste';
import ArtisteCatalog  from 'pages/ArtisteCatalog'


const CatalogPage = props => {
    return (
        <div className="row catalog">
            <div className="w-100 mb-3" style={{paddingLeft:12}}>
                <ul className="catalog-menu">
                    <li className="catalog-menu-items text--large active">Artists</li>
                    <li className="catalog-menu-items text--large">Composers</li>
                    <li className="catalog-menu-items text--large">Publishers</li>
                    <li className="catalog-menu-items text--large">Record labels</li>
                </ul>
            </div>
            <ArtisteCatalog />
        </div>
    )
}

export default CatalogPage;